import { QueryResource } from '@/lib/datx-jsonapi-react';
import { LibrarySubjects } from '@/resources/LibrarySubjects';

export const queryLibrarySubject = (subjectId: string): QueryResource<LibrarySubjects> => () =>
  subjectId && [LibrarySubjects, subjectId];
